import { useContext } from "react";

import { EdecidePanelContext } from "./EdecidePanelContext";

export function useEdecidePanel() {
  const context = useContext(EdecidePanelContext);
  if (!context) {
    throw new Error("useEdecidePanel must be used within a EdecidePanelProvider");
  }
  return context;
}
